// Localização: ./src/components/AnalyticsWrapper.jsx
// Wrapper para inicializar o Google Analytics dentro do contexto do Router

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView, isGAInitialized } from '../utils/analytics';

/**
 * Componente wrapper que inicializa o GA e rastreia mudanças de página
 * Deve ser usado dentro do BrowserRouter
 */
const AnalyticsWrapper = ({ children }) => {
    const location = useLocation();

    // Inicializar GA uma vez quando o componente monta
    useEffect(() => {
        initGA();
    }, []);

    // Rastrear mudanças de página
    useEffect(() => {
        const timer = setTimeout(() => {
            if (isGAInitialized()) {
                trackPageView(location.pathname + location.search, document.title);
            }
        }, 100);

        return () => clearTimeout(timer);
    }, [location]);

    return children;
};

export default AnalyticsWrapper;
